/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * The Ciptex Conference Control API allows you to interact with Ciptex Conferences and control realtime actions
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { CiptexParticipantUpdateFromJSON, CiptexParticipantUpdateToJSON, CiptexRoomFromJSON, CiptexRoomDialToJSON, CiptexRoomJoinToJSON, CiptexSubscriptionUpdateToJSON, CiptexViewerUpdateFromJSON, CiptexViewerUpdateToJSON, } from '../models/index';
/**
 *
 */
export class ParticipantApi extends runtime.BaseAPI {
    /**
     * Dial Participant into conference
     * Dial Participant into conference
     */
    dialRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['roomId'] == null) {
                throw new runtime.RequiredError('roomId', 'Required parameter "roomId" was null or undefined when calling dial().');
            }
            if (requestParameters['ciptexRoomDial'] == null) {
                throw new runtime.RequiredError('ciptexRoomDial', 'Required parameter "ciptexRoomDial" was null or undefined when calling dial().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/room/{RoomId}/participant/dial`.replace(`{${"RoomId"}}`, encodeURIComponent(String(requestParameters['roomId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CiptexRoomDialToJSON(requestParameters['ciptexRoomDial']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Dial Participant into conference
     * Dial Participant into conference
     */
    dial(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.dialRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Join Room as Speaker
     * Join Room as Speaker
     */
    joinAsSpeakerRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['roomId'] == null) {
                throw new runtime.RequiredError('roomId', 'Required parameter "roomId" was null or undefined when calling joinAsSpeaker().');
            }
            if (requestParameters['ciptexRoomJoin'] == null) {
                throw new runtime.RequiredError('ciptexRoomJoin', 'Required parameter "ciptexRoomJoin" was null or undefined when calling joinAsSpeaker().');
            }
            const queryParameters = {};
            if (requestParameters['upgrade'] != null) {
                queryParameters['upgrade'] = requestParameters['upgrade'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/room/{RoomId}/participant/speaker`.replace(`{${"RoomId"}}`, encodeURIComponent(String(requestParameters['roomId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CiptexRoomJoinToJSON(requestParameters['ciptexRoomJoin']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CiptexRoomFromJSON(jsonValue));
        });
    }
    /**
     * Join Room as Speaker
     * Join Room as Speaker
     */
    joinAsSpeaker(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.joinAsSpeakerRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Join Room as Viewer
     * Join Room as Viewer
     */
    joinAsViewerRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['roomId'] == null) {
                throw new runtime.RequiredError('roomId', 'Required parameter "roomId" was null or undefined when calling joinAsViewer().');
            }
            if (requestParameters['ciptexRoomJoin'] == null) {
                throw new runtime.RequiredError('ciptexRoomJoin', 'Required parameter "ciptexRoomJoin" was null or undefined when calling joinAsViewer().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/room/{RoomId}/participant/viewer`.replace(`{${"RoomId"}}`, encodeURIComponent(String(requestParameters['roomId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CiptexRoomJoinToJSON(requestParameters['ciptexRoomJoin']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CiptexRoomFromJSON(jsonValue));
        });
    }
    /**
     * Join Room as Viewer
     * Join Room as Viewer
     */
    joinAsViewer(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.joinAsViewerRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update Participant
     * Update Participant
     */
    updateParticipantRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['roomId'] == null) {
                throw new runtime.RequiredError('roomId', 'Required parameter "roomId" was null or undefined when calling updateParticipant().');
            }
            if (requestParameters['ciptexParticipantUpdate'] == null) {
                throw new runtime.RequiredError('ciptexParticipantUpdate', 'Required parameter "ciptexParticipantUpdate" was null or undefined when calling updateParticipant().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/room/{RoomId}/participant`.replace(`{${"RoomId"}}`, encodeURIComponent(String(requestParameters['roomId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: CiptexParticipantUpdateToJSON(requestParameters['ciptexParticipantUpdate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CiptexParticipantUpdateFromJSON(jsonValue));
        });
    }
    /**
     * Update Participant
     * Update Participant
     */
    updateParticipant(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateParticipantRaw(requestParameters, initOverrides);
            switch (response.raw.status) {
                case 200:
                    return yield response.value();
                case 204:
                    return null;
                default:
                    return yield response.value();
            }
        });
    }
    /**
     * Update Participant Track Subscriptions
     * Update Participant Track Subscriptions
     */
    updateSubscriptionsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['roomId'] == null) {
                throw new runtime.RequiredError('roomId', 'Required parameter "roomId" was null or undefined when calling updateSubscriptions().');
            }
            if (requestParameters['ciptexSubscriptionUpdate'] == null) {
                throw new runtime.RequiredError('ciptexSubscriptionUpdate', 'Required parameter "ciptexSubscriptionUpdate" was null or undefined when calling updateSubscriptions().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/room/{RoomId}/participant/subscriptions`.replace(`{${"RoomId"}}`, encodeURIComponent(String(requestParameters['roomId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CiptexSubscriptionUpdateToJSON(requestParameters['ciptexSubscriptionUpdate']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Update Participant Track Subscriptions
     * Update Participant Track Subscriptions
     */
    updateSubscriptions(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateSubscriptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Set Viewer Status
     * Set Viewer Status
     */
    viewerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['roomId'] == null) {
                throw new runtime.RequiredError('roomId', 'Required parameter "roomId" was null or undefined when calling viewerUpdate().');
            }
            if (requestParameters['ciptexViewerUpdate'] == null) {
                throw new runtime.RequiredError('ciptexViewerUpdate', 'Required parameter "ciptexViewerUpdate" was null or undefined when calling viewerUpdate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/room/{RoomId}/participant/viewer`.replace(`{${"RoomId"}}`, encodeURIComponent(String(requestParameters['roomId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: CiptexViewerUpdateToJSON(requestParameters['ciptexViewerUpdate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CiptexViewerUpdateFromJSON(jsonValue));
        });
    }
    /**
     * Set Viewer Status
     * Set Viewer Status
     */
    viewerUpdate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.viewerUpdateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
